import { render, staticRenderFns } from "./database-documentation.vue?vue&type=template&id=73971b04"
import script from "./database-documentation.vue?vue&type=script&lang=js"
export * from "./database-documentation.vue?vue&type=script&lang=js"
import style0 from "./database-documentation.vue?vue&type=style&index=0&id=73971b04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports